import { DashboardLayout } from '@/components/layout/DashboardLayout';
import ComplianceProofExplorer from '@/components/compliance/ComplianceProofExplorer';
import AuditPortalManager from '@/components/compliance/AuditPortalManager';
import { useTenantStore } from '@/hooks/useTenantStore';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export default function ComplianceProofs() {
  const { tenantId } = useTenantStore();

  if (!tenantId) {
    return (
      <DashboardLayout>
        <Card>
          <CardContent className="flex items-center justify-center py-8">
            <div className="text-center">
              <AlertCircle className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
              <p className="text-muted-foreground">Please select a company</p>
            </div>
          </CardContent>
        </Card>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Compliance Proof Explorer</h1>
          <p className="text-muted-foreground mt-1">
            View and verify on-chain proofs for filings, certificates, and reports
          </p>
        </div>
        <AuditPortalManager />
        <ComplianceProofExplorer companyId={tenantId} />
      </div>
    </DashboardLayout>
  );
}
